<template>
  <template
    v-for="(button, index) in list"
    :key="index"
  >
    <el-button 
      v-if="showFun(button, target)"
      :type="button.type"
      size="small"
      @click="buttonClick(target, button)"
      :loading="target && target[`${button.name}load`]"
    >
      <template #icon v-if="button.icon">
        <svg-icon v-if="button.icon" :iconName='button.icon'></svg-icon>
      </template>
      {{ button.name }}
    </el-button>
  </template>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref
} from 'vue';
// props
const props = defineProps({
  list: { type: Array, default: ()=>{ return [] } },
  target: { type: Object, default: ()=>{ return null } },
});
// emit
const emit = defineEmits([]);

const showFun = (button, target)=>{
  if(button.showFun){
    return button.showFun(target);
  }else{
    return true;
  }
}

const buttonClick = (target, button)=>{
  if(target){
    target[`${button.name}load`] = true;
  }
  button.fun(target, button, ()=>{
    target[`${button.name}load`] = false;
  })
}

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>